import { render, staticRenderFns } from "./CourseCumulEquipe.vue?vue&type=template&id=15b6c4ff"
import script from "./CourseCumulEquipe.vue?vue&type=script&lang=js"
export * from "./CourseCumulEquipe.vue?vue&type=script&lang=js"
import style0 from "./CourseCumulEquipe.vue?vue&type=style&index=0&id=15b6c4ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports